module.exports = __webpack_public_path__ + "static/media/21ECLAC15.8cf8f493.jpg";